var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRightBorderRoundedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    transform: "rotate(-180 19 19)",
    fill: "#fff",
    stroke: "#393E4C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.732c-1.333-.77-1.333-2.694 0-3.464l13.5-7.794c1.333-.77 3 .192 3 1.732v15.588c0 1.54-1.667 2.502-3 1.732L9 20.732z",
    fill: "#5B5B5B"
  })));
}

export default SvgIconRightBorderRoundedArrow;